import { makeStyles, Text, tokens } from "@fluentui/react-components";
import * as React from "react";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
    card: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: "12px",
        boxShadow: tokens.shadow16,
        padding: "1.5rem",
    },
    ul: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    },
});

export const Id = "39dfb800-272a-4b44-95e2-b9b2400c2d13";
export const Title = "What is Ianus Guard?";
export const Subtitle = "Learn about the platform";
export const Description = "Find out what Ianus Guard is, and what you can do with it";
export const Keywords = ["explanation", "platform", "what"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <CardSection title="What is Ianus Guard?">
                <Text>
                    Ianus Guard is a <strong>SaaS platform</strong> built to simplify the <strong>licensing of publisher software modules</strong>.  
                    It includes an <strong>open-source integration toolkit</strong> to make implementation straightforward.
                    <br />
                    <br />
                    The platform is guided by three principles:
                </Text>
                <ul className={styles.ul}>
                    <li><strong>Security</strong> – Cryptographically signed licenses for tamper-proof validation</li>
                    <li><strong>Stability</strong> – Reliable offline operation in mission-critical environments</li>
                    <li><strong>Ease of Use</strong> – Clean developer and end-user experience</li>
                </ul>
            </CardSection>

            <CardSection title="Primary Use Case">
                <Text>
                    Ianus Guard was originally designed for seamless integration with <strong>Microsoft® Dataverse</strong>.  
                    While Dataverse offers rich extensibility, it lacks built-in license management.
                    <br />
                    <br />
                    Most licensing solutions rely on online validation — which fails in disconnected scenarios.  
                    Ianus Guard’s core strength is <strong>offline-capable license validation</strong>.
                </Text>
                <br />
                <Text>
                    Licenses function similarly to <strong>JWTs (JSON Web Tokens)</strong>, and can be validated using only the open-source toolkit, which solely interacts with Dataverse for validation.
                </Text>
                <br />
                <Text>Supports deep integration into:</Text>
                <ul className={styles.ul}>
                    <li>PCFs (PowerApps Component Framework components)</li>
                    <li>Plugins</li>
                    <li>Canvas Apps</li>
                    <li>Power Automate Flows</li>
                    <li>Model-driven forms (via PCFs or custom JS)</li>
                    <li>External tools (any tech stack connected to Dataverse, by calling the ian_IanusLicenseValidation custom API)</li>
                </ul>
            </CardSection>

            <CardSection title="Disclaimer">
                <Text>
                    Microsoft and Dataverse are trademarks of Microsoft Corporation.  
                    Ianus Guard is an independent platform and is not affiliated with or endorsed by Microsoft.
                </Text>
            </CardSection>
        </div>
    );
});
